import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export default () => {
  const appSettings = useSelector(state => state.profileReducer?.doctor?.user?.appSettings)
  return useMemo(() => (appSettings ? JSON.parse(appSettings) : {}), [appSettings])
}
